<template>
  <a-modal width="45%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>费率信息</b>
    </a-divider>
    <a-table :data-source="rateTypeList" rowKey="feeRateTypeCode" :columns="skuColumns" :pagination="false" bordered>
      <span slot="feeRatePct" slot-scope="text, record">
        <a-input-number v-model="record.feeRatePct" style="width: 80%" :min="0" :max="100" :step="0.01" placeholder="费率" />
        <span>%</span>
      </span>
      <span slot="feeUpperAmtPcnt" slot-scope="text, record">
        <a-input-number v-model="record.feeUpperAmtPcnt" style="width: 80%" :min="0" :max="100" :step="0.01" placeholder="单笔手续费封顶" />
        <span>元</span>
      </span>
      <span slot="feeLowerAmtPcnt" slot-scope="text, record">
        <a-input-number v-model="record.feeLowerAmtPcnt" style="width: 80%" :min="0" :max="100" :step="0.01" placeholder="单笔手续费保低" />
        <span>元</span>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'FeeRateForm',
  props: {},
  data() {
    return {
      rateTypeList: [],
      open: false,
      skuColumns: [
        { title: '费率类型', dataIndex: 'feeRateTypeName', key: 'feeRateTypeName' },
        { title: '手续费率(%)', dataIndex: 'feeRatePct', key: 'feeRatePct', scopedSlots: { customRender: 'feeRatePct' } },
        { title: '单笔手续费封顶', dataIndex: 'feeUpperAmtPcnt', key: 'feeUpperAmtPcnt', scopedSlots: { customRender: 'feeUpperAmtPcnt' } },
        { title: '单笔手续费保低', dataIndex: 'feeLowerAmtPcnt', key: 'feeLowerAmtPcnt', scopedSlots: { customRender: 'feeLowerAmtPcnt' } },
      ],
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    reset() {
      this.rateTypeList = []
    },
    resetRateType() {
      this.rateTypeList = []
      if (this.customDict.MerchantRateTypeEnum) {
        this.customDict.MerchantRateTypeEnum.forEach(item => {
          const newData = {
            feeRateTypeCode: item.type,
            feeRateTypeName: item.name,
            feeRatePct: 0,
            feeUpperAmtPcnt: 0,
            feeLowerAmtPcnt: 0,
          };
          this.rateTypeList.push(newData)
        })
      }
    },
    show(rateTypeList) {
      if (rateTypeList && rateTypeList.length > 0) {
        this.rateTypeList = rateTypeList;
      } else {
        this.resetRateType()
      }
      this.open = true
    },
    onOk() {
      this.open = false
      this.$emit('rateType', this.rateTypeList)
      this.reset()
    },
  }
}
</script>
